import moment from 'moment-timezone'
import { useCallback } from 'react'

export const useGetDiffTimer = (time?: string | number | Date) => {
  const handleCompareDates = useCallback(
    (dateOne: string | number | Date, dateTwo: string | number | Date) => {
      const momentDate = moment(dateOne)
      const dateLimit = moment(dateTwo)

      const diffTime = moment.duration(dateLimit.diff(momentDate))

      const minutes = diffTime?.minutes()
      const seconds = diffTime?.seconds()

      return {
        minutes,
        seconds,
      }
    },
    [],
  )

  const handleGetTimerAlternative = useCallback(() => {
    if (time) {
      const timer = new Date(time).getTime() - new Date().getTime()

      if (timer > 0) {
        const totalSeconds = Math.floor(timer / 1000)
        const minutes = Math.floor(totalSeconds / 60)
        const seconds = totalSeconds % 60

        return {
          minutes,
          seconds,
        }
      }

      if (timer <= 0) {
        return {
          minutes: 0,
          seconds: 0,
        }
      }
    }
  }, [time])

  return {
    handleGetTimerAlternative,
    handleCompareDates,
  }
}
